<template>
    <v-list-item  :key="peer.id">
        <v-list-item-avatar color="secondary">
            <v-icon dark>mdi-account-circle</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title v-text="peer.name != '' ? `${peer.name}` : `Anonymous`"></v-list-item-title>
            <v-list-item-subtitle v-text="peer.roleName.toUpperCase()"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon class="pt-2" v-if="peer.roleName == 'waiting-room' && local_peer.roleName != 'guest'">
            <v-btn x-small @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);" color="primary">Admit</v-btn>
        </v-list-item-icon>
        <v-list-item-icon class="pt-2" v-else>
            <v-btn icon @click="meeting.enablePeerAudio(peer, !meeting.peer_audio_enabled[peer.id])" x-small>
                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]">mdi-microphone-off</v-icon>
                <v-icon v-else>mdi-microphone</v-icon>
            </v-btn>
            <v-btn icon @click="meeting.enablePeerVideo(peer, !meeting.peer_video_enabled[peer.id])" x-small>
                <v-icon v-if="!meeting.peer_video_enabled[peer.id]">mdi-video-off</v-icon>
                <v-icon v-else>mdi-video</v-icon>
            </v-btn>
            <meeting-participant-menu :peer="peer" v-if="meeting.permissions.changeRole"></meeting-participant-menu>
        </v-list-item-icon>
    </v-list-item>
</template>

<script>
import { useMeetingStore } from '../stores/meeting'
import MeetingParticipantMenu from './MeetingParticipantMenu.vue'

export default {
    name: 'MeetingParticipantListItem',
    props: ['peer', 'local_peer'],
    components: { MeetingParticipantMenu },
    data: function() {
        return {
            meeting: null
        }
    },
    created: function() {
        this.meeting = useMeetingStore()
    }
}
</script>
